import TimePeriodCard from 'features/Weather/components/TimePeriodCard/TimePeriodCard';
import { joinClasses } from 'utils/componentStyles/style.utils';

/**
 * Displays one TimePeriodCard for each weather entry.
 *
 * The parent feature provides the entries, detail definitions, and card labels.
 * This lets Marine and Fire Danger share the card layout while choosing their
 * own content. The getCard callbacks receive the entry for the current card.
 */
const WeatherCardGrid = ({
  entries = [],
  details = [],
  emptyMessage = 'No weather data available.',
  getCardKey = (entry, index) => entry?.iso8601 ?? entry?.utcTime ?? entry?.id ?? index,
  getCardTitle = () => 'Weather Conditions',
  getCardSubtitle,
  getCardIcon,
  getCardClassName,
  containerClassName,
  cardContainerClassName,
  detailsContainerClassName,
  detailContainerClassName,
  detailLabelClassName,
  cardHeadingLevel = 'h3',
}) => {
  const availableEntries = entries.filter(Boolean);

  if (!availableEntries.length) {
    return <p className="m-0 text-secondary">{emptyMessage}</p>;
  }

  return (
    <div className={joinClasses('d-grid gap-3', containerClassName)}>
      {availableEntries.map((entry, index) => (
        <TimePeriodCard
          key={getCardKey(entry, index)}
          data={entry}
          title={getCardTitle(entry)}
          subtitle={getCardSubtitle?.(entry)}
          subtitleIcon={getCardIcon?.(entry)}
          details={details}
          containerClassName={joinClasses(
            'flex-grow-1',
            cardContainerClassName,
            getCardClassName?.(entry),
          )}
          detailsContainerClassName={detailsContainerClassName}
          detailContainerClassName={detailContainerClassName}
          detailLabelClassName={detailLabelClassName}
          headingLevel={cardHeadingLevel}
        />
      ))}
    </div>
  );
};

export default WeatherCardGrid;
